export const dashboardPalette = {
  primary: "#3f7a2a",
  secondary: "#5f8ee6",
  accent: "#a44b12",
  surface: "#ffffff",
  border: "rgba(39, 55, 24, 0.08)",
  text: "#172112",
  muted: "#62715d",
  grid: "rgba(39, 55, 24, 0.08)",
};

export const barChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: "index",
    intersect: false,
  },
  plugins: {
    legend: {
      position: "top",
      align: "end",
      labels: {
        usePointStyle: true,
        pointStyle: "circle",
        boxWidth: 8,
        color: dashboardPalette.text,
        font: {
          size: 12,
          weight: "600",
        },
      },
    },
    tooltip: {
      backgroundColor: "#172112",
      titleColor: "#f8faf7",
      bodyColor: "#dbe5d5",
      padding: 12,
      cornerRadius: 12,
      displayColors: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        color: dashboardPalette.muted,
        font: {
          size: 11,
        },
      },
    },
    y: {
      border: {
        dash: [4, 4],
      },
      grid: {
        color: dashboardPalette.grid,
        drawBorder: false,
      },
      ticks: {
        color: dashboardPalette.muted,
        precision: 0,
        font: {
          size: 11,
        },
      },
      beginAtZero: true,
    },
  },
};

export const doughnutChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: "66%",
  plugins: {
    legend: {
      position: "bottom",
      labels: {
        usePointStyle: true,
        pointStyle: "circle",
        padding: 18,
        color: dashboardPalette.text,
        font: {
          size: 12,
          weight: "600",
        },
      },
    },
    title: {
      display: false,
    },
    tooltip: {
      backgroundColor: "#172112",
      titleColor: "#f8faf7",
      bodyColor: "#dbe5d5",
      padding: 12,
      cornerRadius: 12,
    },
  },
};
